export const isStoreAdmin = (role) => role === 'store_admin';

export const isAllStoresAdmin = (role) =>
  ['admin', 'super_admin', 'super-admin'].includes(role);
